export default "./images/WN110.jpg";